import { useBoolean } from '@chakra-ui/hooks'
import { useToast } from '@chakra-ui/react'
import dayjs from 'dayjs'
import { createContext, FC, useCallback, useMemo, useState } from 'react'
import { AiOutlineBarChart } from 'react-icons/ai'
import Swal from 'sweetalert2'
import { useImmer } from 'use-immer'

import useAuth from '@hook/shared/use-auth'

import {
  parseReabRoutes,
  parseReabRoutesExport
} from '@helper/grid/parametrization-curve'
import {
  decrypterHeaderStorange,
  encrypteHeaderStorange
} from '@helper/util/cryptoStorange'
import parametrizationReab from '@service/parametrization-reab'

import { ILayoutFilter } from '@base/@types/components/Layout/Filters'
import {
  ITableGridAction,
  ITableHeader,
  Pagination
} from '@base/@types/components/Layout/TableGrid'
import { ILayoutToolsAction } from '@base/@types/components/Layout/Tools'
import {
  IParams,
  IParamsEdit,
  IReabRoutesProvider,
  ITooglesParams,
  IUpdateParams,
  IUpdateParamsDate,
  IUpdateParamsEdit
} from '@base/@types/providers/Parametrization/ReabRoutesProvider'
import reabRouteLevelOneHeader from '@base/variables/headers/parametrization/reab-route-one'
import reabRouteLevelTwoHeader from '@base/variables/headers/parametrization/reab-route-two'

const ReabRouteProvider: FC = ({ children }) => {
  const toast = useToast()
  const [loading, setLoading] = useState(false)
  const [filters, setFilters] = useBoolean(false)
  const [fastQuery, _setFastQuery] = useState<string>('')
  const [query, setQuery] = useState('')
  const [filename, setFilename] = useState('PRM Rotas - Relatório')
  const [_selected, _setSelected] = useState<any>()
  const [fetching, _setFetching] = useState(false)
  const [_error] = useState<string | undefined>()
  const [loadingEdit] = useState(false)
  const [pagination, updatePagination] = useImmer<Pagination>({
    actualPage: 0,
    rows: 0,
    totalPages: 0,
    totalRows: 0,
    skip: 0
  })
  const [historic, updateHistoric] = useImmer<any[]>([])
  const [loadingHistoric, setLoadingHistoric] = useState(false)
  const [companieId, setCompanieId] = useState('')

  const { companies: authCompanies } = useAuth()

  const [data, updateData] = useImmer<any[]>([])
  const [dataOriginal, updateDataOriginal] = useImmer<any[]>([])
  const [selected, setSelectedOne] = useState(0)

  const [hiddenColumns, _updateHiddenColumns] = useImmer<string[]>([])
  const [filterEdit] = useImmer({
    centers: [],
    products: []
  })

  const [tooglesTable, updateToogleParams] = useImmer({
    pendentes: true,
    aprovados: true,
    recusados: true
  })

  const handleToogleTable = ({ name, value }: ITooglesParams) => {
    updateToogleParams(draft => {
      draft[name] = value
    })
  }

  const dateNow = new Date()
  const dateEnd = dateNow.setDate(dateNow.getDate() - 30)

  const [paramsDates, updateDatesParams] = useImmer({
    dateInit: dayjs(dateEnd).format('YYYY-MM-DD'),
    dateEnd: dayjs(new Date()).format('YYYY-MM-DD')
  })

  const handleParamsDate = ({ name, value }: IUpdateParamsDate) => {
    updateDatesParams(draft => {
      draft[name] = value
    })
  }
  const diaSemanas = [
    { value: 1, label: 'Segunda-feira' },
    { value: 2, label: 'Terça-feira' },
    { value: 3, label: 'Quarta-feira' },
    { value: 4, label: 'Quinta-feira' },
    { value: 5, label: 'Sexta-feira' },
    { value: 6, label: 'Sábado' },
    { value: 7, label: 'Domingo' }
  ]

  // Método para buscar o label pelo valor
  // eslint-disable-next-line react-hooks/exhaustive-deps
  function getLabelByValue(value: number) {
    const dia = diaSemanas.find(d => d.value === value)
    return dia ? dia.label : 'Valor inválido'
  }
  const [paramsEdit, updateEditParams] = useImmer<IParamsEdit>({
    id: 0,
    centroId: '',
    lojaId: '',
    tipo: '',
    agrupar: '2',
    carga: '',
    veiculo: '',
    diaSemana: ''
  })

  const handleUpdateEditParams = useCallback(
    async ({ name, value }: IUpdateParamsEdit) => {
      updateEditParams(draft => {
        draft[name] = value
      })
    },
    [updateEditParams]
  )

  const getCenters = useCallback(async () => {}, [])

  const [params, updateParams] = useImmer<IParams>({
    lojasIds: [],
    mundoIds: [],
    categoriasCompactasIds: [],
    fornecedoresIds: [],
    produtosIds: [],
    statusIds: [],
    curvaAbc: [],
    curvaIgualZero: false,
    produtoSemFornecedor: false
  })

  const [headers, updateHeaders] = useImmer<ITableHeader[]>(
    reabRouteLevelOneHeader
  )
  const [headers2] = useImmer<ITableHeader[]>(reabRouteLevelTwoHeader)
  const handleHeaderLocalStorange = useCallback(() => {
    if (!localStorage.getItem('reabRouteLevelOneHeader')) {
      encrypteHeaderStorange('reabRouteLevelOneHeader', headers)
    } else {
      localStorage.removeItem('reabRouteLevelOneHeader')
      encrypteHeaderStorange('reabRouteLevelOneHeader', headers)
    }
  }, [headers])

  const exportData = useCallback(async () => {}, [])

  const toggleColumn = useCallback(
    (index: number, column: number) => {
      const newHeaders = [...headers]

      newHeaders[index].columns[column] = {
        id: newHeaders[index].columns[column].id,
        name: newHeaders[index].columns[column].name,
        show: !newHeaders[index].columns[column].show,
        notShowColumn: newHeaders[index].columns[column].notShowColumn
          ? !newHeaders[index].columns[column].notShowColumn
          : true
      }

      updateHeaders(newHeaders)
      handleHeaderLocalStorange()
    },
    [handleHeaderLocalStorange, headers, updateHeaders]
  )
  const handleStorange = useCallback(async () => {
    if (localStorage.getItem('reabRouteLevelOneHeader')) {
      const newHeader = decrypterHeaderStorange('reabRouteLevelOneHeader')
      newHeader[0].columns[0] = {
        id: newHeader[0].columns[0].id,
        name: newHeader[0].columns[0].name,
        show: newHeader[0].columns[0].show
      }
      updateHeaders(newHeader)
    }
  }, [updateHeaders])
  const handleUpdateParams = ({ name, value }: IUpdateParams) => {
    updateParams(draft => {
      if (name === 'curvaIgualZero') {
        draft[name] = Boolean(value)
      } else {
        draft[name] = value
      }
      if (name === 'produtoSemFornecedor') {
        draft[name] = Boolean(value)
      } else {
        draft[name] = value
      }
    })
  }

  const handlePageChange = useCallback(async (_page: number) => {
    setLoading(true)
  }, [])

  const getData = useCallback(
    async (id: any) => {
      setLoading(true)
      setCompanieId(id)

      // await getMaintence()

      encrypteHeaderStorange('reabRouteLevelOneHeader', headers)

      handleStorange()

      try {
        parametrizationReab
          .getParamsReabRoute(id)
          .then(({ data: { data } }) => {
            const agrupados = Object.values(
              data.reduce((acc: any, item: any) => {
                const key = `${item.idRota}-${item.centroDistribuicaoId}`
                const lojaEntry = `${item.lojaId}-${item.lojaNome}|` // Cria a string de entrada para lojaDesc
                const diaDaSemanaEntry = `${getLabelByValue(item.diaDaSemana)}|` // Cria a string de entrada para diaDaSemanaDesc

                if (!acc[key]) {
                  acc[key] = {
                    ...item,
                    lojaDesc: lojaEntry,
                    diaDaSemanaDesc: diaDaSemanaEntry // Inicializando a nova propriedade
                  }
                } else {
                  // Adiciona à lojaDesc apenas se ainda não existir
                  if (!acc[key].lojaDesc.includes(lojaEntry)) {
                    acc[key].lojaDesc += lojaEntry
                  }

                  // Adiciona à diaDaSemanaDesc apenas se ainda não existir
                  if (!acc[key].diaDaSemanaDesc.includes(diaDaSemanaEntry)) {
                    acc[key].diaDaSemanaDesc += diaDaSemanaEntry
                  }
                }
                return acc
              }, {})
            )

            updateDataOriginal(draft => {
              return draft.filter(item => item.status === 99).concat(data)
            })
            setCompanieId(id)

            updatePagination(pagination)
            setLoading(false)
            updateData(agrupados)
          })
          .catch(() => {
            updateData([])
            updateDataOriginal([])
            setLoading(false)
          })
      } catch {
        setLoading(false)
      }
    },
    [
      headers,
      handleStorange,
      updateDataOriginal,
      updatePagination,
      pagination,
      updateData,
      getLabelByValue
    ]
  )

  const updateDataCurve = useCallback(async () => {
    setLoading(true)

    try {
      const { data: _res } =
        await parametrizationReab.putParamsReabTypeOfVeichule({
          id: paramsEdit.id
        })
      toast({
        title: 'Sucesso.',
        description: 'Rota editada com Sucesso',
        status: 'success',
        duration: 2000,
        isClosable: true
      })
    } catch (error: any) {
      const message =
        error.response?.status === 400
          ? error.response?.data?.message
          : 'Ocorreu um problema interno. Tente novamente mais tarde'
      toast({
        title: 'Atenção.',
        description: message,
        status: 'warning',
        duration: 3000,
        isClosable: true
      })
      setLoading(false)
    }
    setSelectedOne(0)
    getData(companieId)
  }, [getData, companieId, paramsEdit.id, toast])

  const deleteData = useCallback(async () => {
    setLoading(true)
    const deleteItem = data.find(x => x.idRotaFormatado === selected)
    try {
      await parametrizationReab.deleteParamsRoute(deleteItem.idRota)

      toast({
        title: 'Sucesso.',
        description: 'Registro deletado com Sucesso',
        status: 'success',
        duration: 2000,
        isClosable: true
      })
    } catch (error: any) {
      const message =
        error.response?.status === 400
          ? error.response?.data?.message
          : 'Ocorreu um problema interno. Tente novamente mais tarde'
      toast({
        title: 'Atenção.',
        description: message,
        status: 'warning',
        duration: 3000,
        isClosable: true
      })
      setLoading(false)
    }
    setSelectedOne(0)
    getData(companieId)
  }, [data, getData, companieId, selected, toast])

  const clearParams = useCallback(async () => {
    if (selected === 0) {
      updateEditParams({
        id: 0,
        centroId: '',
        lojaId: '',
        agrupar: '2',
        veiculo: '',
        tipo: '',
        carga: '',
        diaSemana: ''
      })
    }
  }, [selected, updateEditParams])
  const createData = useCallback(async () => {
    setLoading(true)
    const arrayRoutes: {
      empresaId: string | number
      setorId: number
      tipoVeiculoId: any
      centroDistribuicaoId: any
      lojaId: any
      agrupar: boolean
      cargaEspecial: number
    }[] = []
    paramsEdit.lojaId.map((x: any) => {
      const route = {
        ...(paramsEdit.id && paramsEdit.id !== 0
          ? { idRota: paramsEdit.id }
          : {}),
        empresaId: companieId === '' ? authCompanies[0] : companieId,
        setorId: paramsEdit.tipo.value,
        tipoVeiculoId: paramsEdit.veiculo.value,
        centroDistribuicaoId: paramsEdit.centroId.value,
        lojaId: x.value,
        agrupar: paramsEdit.agrupar === '1',
        cargaEspecial: paramsEdit.carga === '' ? null : Number(paramsEdit.carga)
      }
      arrayRoutes.push(route)
    })
    const arratRouteNew: any[][] = []
    paramsEdit?.diaSemana?.forEach((element: any) => {
      const novoArray = arrayRoutes.map(item => ({
        ...item,
        diaDaSemana: element.value
      }))
      arratRouteNew.push(novoArray)
    })

    parametrizationReab
      .putParamsRoute({
        empresaId: companieId === '' ? authCompanies[0] : companieId,
        rotasReab: arratRouteNew.flat()
      })
      .then(() => {
        // Exibe o toast de sucesso somente se a requisição for bem-sucedida
        getData(companieId)
        toast({
          title: 'Sucesso.',
          description: 'Rota cadastrada com Sucesso',
          status: 'success',
          duration: 2000,
          isClosable: true
        })
      })
      .catch((error: any) => {
        // Extrai e exibe a mensagem de erro em caso de falha
        const message =
          error.response?.status === 400
            ? error.response?.data?.message
            : 'Ocorreu um problema interno. Tente novamente mais tarde'

        toast({
          title: 'Atenção.',
          description: message,
          status: 'warning',
          duration: 3000,
          isClosable: true
        })
        setLoading(false) // Atualiza o estado de loading em caso de erro
      })
    setSelectedOne(0)
    updateEditParams({
      id: 0,
      centroId: '',
      lojaId: '',
      agrupar: '2',
      veiculo: '',
      tipo: '',
      carga: '',
      diaSemana: ''
    })
    // CreateData
  }, [
    paramsEdit.lojaId,
    paramsEdit?.diaSemana,
    paramsEdit.id,
    paramsEdit.tipo.value,
    paramsEdit.veiculo.value,
    paramsEdit.centroId.value,
    paramsEdit.agrupar,
    paramsEdit.carga,
    companieId,
    authCompanies,
    updateEditParams,
    getData,
    toast
  ])

  const filtersList = useMemo<ILayoutFilter[]>(() => {
    return []
  }, [])

  const actions = useMemo<ILayoutToolsAction[]>(() => {
    return [
      {
        type: 'export',
        exports: [
          {
            type: 'excel',
            entity: 'parameterReabRoutes',
            data,
            headers,
            parser: parseReabRoutes
          }
        ]
      },
      {
        type: 'columns',
        data: headers,
        onToggleColumn: toggleColumn
      },

      {
        type: 'reabRouteHistoric',
        data: data,
        onUpdate: updateData
      }
    ]
  }, [data, headers, toggleColumn, updateData])

  const handleEditParams = useCallback(
    async (index: any) => {
      const dataResponse = await dataOriginal
      const idData = await dataResponse.filter(x => x.idRotaFormatado === index)
      const uniqueLojasId = idData.filter(
        (item, index, self) =>
          index === self.findIndex(obj => obj.lojaId === item.lojaId)
      )
      const uniqueDiaDaSemana = idData.filter(
        (item, index, self) =>
          index === self.findIndex(obj => obj.diaDaSemana === item.diaDaSemana)
      )
      if (idData.length > 0) {
        handleUpdateEditParams({
          name: 'id',
          value: idData[0].idRota
        })
        handleUpdateEditParams({
          name: 'centroId',
          value: {
            value: idData[0].centroDistribuicaoId,
            label:
              idData[0].centroDistribuicaoId +
              ' - ' +
              idData[0].centroDistribuicaoNome
          }
        })
        handleUpdateEditParams({
          name: 'lojaId',
          value: uniqueLojasId.map(item => ({
            value: item.lojaId,
            label: item.lojaId + ' - ' + item.lojaNome
          }))
        })
        handleUpdateEditParams({
          name: 'diaSemana',
          value: uniqueDiaDaSemana.map(item => ({
            value: item.diaDaSemana,
            label: item.diaDaSemana + ' - ' + getLabelByValue(item.diaDaSemana)
          }))
        })
        handleUpdateEditParams({
          name: 'veiculo',
          value: {
            value: idData[0].tipoVeiculoId,
            label: idData[0].tipoVeiculoId + ' - ' + idData[0].tipoVeiculoNome
          }
        })
        handleUpdateEditParams({
          name: 'agrupar',
          value: idData[0].agrupar === true ? '1' : '2'
        })
        handleUpdateEditParams({
          name: 'tipo',
          value: {
            value: idData[0].setorId,
            label: idData[0].setorNome
          }
        })
        handleUpdateEditParams({
          name: 'carga',
          value: idData[0]?.cargaEspecial
        })
      }
    },
    [dataOriginal, getLabelByValue, handleUpdateEditParams]
  )

  const handleSelect = useCallback(
    async (index: any) => {
      const similarProduct = index['id-id']
      const newSelected = selected

      setSelectedOne(prev => (prev !== similarProduct ? similarProduct : 0))
      if (newSelected === similarProduct) {
        updateEditParams({
          id: 0,
          centroId: '',
          lojaId: '',
          agrupar: '2',
          veiculo: '',
          tipo: '',
          carga: 0,
          diaSemana: ''
        })
      } else {
        handleEditParams(index['id-id'])
      }
    },
    [setSelectedOne, handleEditParams, selected, updateEditParams]
  )

  const handleRouteVeichule = useCallback(
    async (companieId: any) => {
      setCompanieId(companieId.value)
      getData(companieId.value)
    },
    [getData]
  )
  const postUpload = useCallback(
    async (event: any) => {
      setLoading(true)

      parametrizationReab
        .uploadTypeOfVeichule({
          file: event.target.files[0],
          id: companieId
        })
        .then(() => {
          getData(companieId)
          toast({
            title: 'Sucesso',
            description: 'Parâmetros carregados com sucesso',
            status: 'success',
            duration: 2000,
            isClosable: true
          })
          setLoading(false)
        })
        .catch(response => {
          let htmlLines = ''
          for (let aux = 0; aux < response.response.data.data.length; aux++) {
            htmlLines += '<li>' + response.response.data.data[aux] + '</>'
          }
          Swal.fire({
            title: '<strong>Ops, houver um error</u></strong>',
            icon: 'error',
            html: 'Verificar os erros abaixo, ' + htmlLines,
            showCloseButton: true,
            showCancelButton: true,
            focusConfirm: false
          })
          setLoading(false)
        })
    },
    [companieId, getData, toast]
  )
  const getHistoric = useCallback(
    async (id: any) => {
      setLoadingHistoric(true)

      try {
        await parametrizationReab
          .getParamsReabRouteHistoric(id)
          .then(({ data: { data } }) => {
            updateHistoric(data)
            setLoadingHistoric(false)
          })
      } catch (error: any) {
        const message =
          error.response?.status === 400
            ? error.response?.data?.message
            : 'Ocorreu um problema interno. Tente novamente mais tarde'
        toast({
          title: 'Atenção.',
          description: message,
          status: 'warning',
          duration: 3000,
          isClosable: true
        })
        setLoadingHistoric(false)
      }
    },
    [updateHistoric, toast]
  )
  const tableInteraction = useMemo<ITableGridAction[]>(() => {
    return [
      {
        type: 'checkbox',
        icon: <AiOutlineBarChart />,
        onChange: handleSelect,
        selecteds: selected,
        isMulti: false
      }
    ]
  }, [selected, handleSelect])
  return (
    <ReabRouteContext.Provider
      value={{
        loading,
        loadingEdit,
        data: parseReabRoutes(data),
        params,
        headers,
        fetching,
        actions,
        tableInteraction,
        clearParams,
        selected,
        filterEdit,
        paramsEdit,
        paramsDates,
        tooglesTable,
        filename,
        query,
        filters,
        dataOriginal: parseReabRoutesExport(dataOriginal),
        hiddenColumns,
        handlePageChange,
        pagination,
        fastQuery,
        filtersList,
        toggleColumn,
        handleUpdateParams,
        handleSelect,
        getCenters,
        handleParamsDate,
        setQuery,
        getData,
        exportData,
        createData,
        handleUpdateEditParams,
        handleToogleTable,
        updateDataCurve,
        companieId,
        deleteData,
        setFilters,
        setFilename,
        postUpload,
        handleRouteVeichule,
        getHistoric,
        loadingHistoric,
        historic,
        headers2
      }}
    >
      {children}
    </ReabRouteContext.Provider>
  )
}

export default ReabRouteProvider
export const ReabRouteContext = createContext<IReabRoutesProvider>(
  {} as IReabRoutesProvider
)
